<div class="role-selector-container">
  <!-- Search dropdown header -->
  <div class="search-header" (click)="toggleDropdown()">
    <span class="search-text">{{'access_control.dialog.search_role' | translate}}</span>
    <svg class="chevron" [class.rotated]="isOpen" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <polyline points="6,9 12,15 18,9"></polyline>
    </svg>
  </div>

  <!-- Roles list -->
  <div class="roles-list" [class.open]="isOpen">
    <div *ngFor="let role of roles" class="role-item">
      <label class="role-label">
        <input 
          type="checkbox" 
          class="role-checkbox"
          [checked]="role.selected"
          (change)="toggleRole(role.id)"
        />
        <span class="checkmark" [class.checked]="role.selected">
          <svg *ngIf="role.selected" class="check-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
            <polyline points="20,6 9,17 4,12"></polyline>
          </svg>
        </span>
        <span class="role-name">{{ role.name }}</span>
      </label>
    </div>
  </div>
</div>